<!-- Component for showing print version of memorial guide (non-interactive / all available plans) -->
<template>
	<div
		v-if="sessionStore.activeSession"
		class="max-w-300"
	>
		<div
			v-for="(plan, index) in sessionStore.activePlans"
			:key="plan.id"
			:class="index > 0 ? 'break-before-page' : ''"
		>
			<h2
				class="w-full pb-4 pl-6 text-3xl capitalize italic print:flex print:items-baseline print:justify-between print:border-b-3 print:border-slate-900 print:text-lg print:font-bold print:not-italic"
			>
				{{
					t(
						'plan.memorialGuideTitle',
						{ name: `${plan.firstName} ${plan.lastName}`.trim() },
						plan.firstName || plan.lastName ? 0 : 1
					)
				}}
				<PrintDate />
			</h2>

			<MemorialGuideForm
				:plan="plan"
				:index="index"
			/>
		</div>
	</div>

	<div v-else>{{ t('memorialGuide.noActiveSession') }}</div>
</template>

<script setup lang="ts">
import PrintDate from '@/components/common/PrintDate.vue'
import MemorialGuideForm from '@/components/memorialGuide/MemorialGuideForm.vue'
import { usePresentationLocale } from '@/i18n'
import { useSessionStore } from '@/stores/session'

const { t } = usePresentationLocale()
const sessionStore = useSessionStore()
</script>

<style scoped>
@import '@/assets/styles/memorialGuidePrint.css';
</style>
